// @ts-nocheck
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAppVersionsClient {
    /**
     * @param appCode (optional) 
     * @param channel (optional) 
     * @param status (optional) 
     * @return OK
     */
    getAll(appCode?: string | undefined, channel?: string | undefined, status?: string | undefined, signal?: AbortSignal): Promise<AppVersionResponse[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    create(body?: CreateAppVersionRequest | undefined, signal?: AbortSignal): Promise<AppVersionResponse>;
    /**
     * @return OK
     */
    getById(versionId: number, signal?: AbortSignal): Promise<AppVersionResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    update(versionId: number, body?: UpdateAppVersionRequest | undefined, signal?: AbortSignal): Promise<AppVersionResponse>;
    /**
     * @return No Content
     */
    delete(versionId: number, signal?: AbortSignal): Promise<void>;
    /**
     * @param file (optional) 
     * @return OK
     */
    package(versionId: number, file?: FileParameter | undefined, signal?: AbortSignal): Promise<AppVersionResponse>;
    /**
     * @return OK
     */
    publish(versionId: number, signal?: AbortSignal): Promise<AppVersionResponse>;
    /**
     * @return OK
     */
    archive(versionId: number, signal?: AbortSignal): Promise<AppVersionResponse>;
}

export class AppVersionsClient implements IAppVersionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param appCode (optional) 
     * @param channel (optional) 
     * @param status (optional) 
     * @return OK
     */
    getAll(appCode?: string | undefined, channel?: string | undefined, status?: string | undefined, signal?: AbortSignal): Promise<AppVersionResponse[]> {
        let url_ = this.baseUrl + "/api/admin/app-versions?";
        if (appCode === null)
            throw new globalThis.Error("The parameter 'appCode' cannot be null.");
        else if (appCode !== undefined)
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&";
        if (channel === null)
            throw new globalThis.Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<AppVersionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    create(body?: CreateAppVersionRequest | undefined, signal?: AbortSignal): Promise<AppVersionResponse> {
        let url_ = this.baseUrl + "/api/admin/app-versions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AppVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201;
            return Promise.resolve<AppVersionResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = resultData409;
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionResponse>(null as any);
    }

    /**
     * @return OK
     */
    getById(versionId: number, signal?: AbortSignal): Promise<AppVersionResponse> {
        let url_ = this.baseUrl + "/api/admin/app-versions/{versionId}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AppVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(versionId: number, body?: UpdateAppVersionRequest | undefined, signal?: AbortSignal): Promise<AppVersionResponse> {
        let url_ = this.baseUrl + "/api/admin/app-versions/{versionId}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<AppVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionResponse>(null as any);
    }

    /**
     * @return No Content
     */
    delete(versionId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/app-versions/{versionId}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    package(versionId: number, file?: FileParameter | undefined, signal?: AbortSignal): Promise<AppVersionResponse> {
        let url_ = this.baseUrl + "/api/admin/app-versions/{versionId}/package";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPackage(_response);
        });
    }

    protected processPackage(response: AxiosResponse): Promise<AppVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionResponse>(null as any);
    }

    /**
     * @return OK
     */
    publish(versionId: number, signal?: AbortSignal): Promise<AppVersionResponse> {
        let url_ = this.baseUrl + "/api/admin/app-versions/{versionId}/publish";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<AppVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionResponse>(null as any);
    }

    /**
     * @return OK
     */
    archive(versionId: number, signal?: AbortSignal): Promise<AppVersionResponse> {
        let url_ = this.baseUrl + "/api/admin/app-versions/{versionId}/archive";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: AxiosResponse): Promise<AppVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionResponse>(null as any);
    }
}

export interface IAuthClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    login(body?: LoginRequest | undefined, signal?: AbortSignal): Promise<AuthenticationResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    refresh(body?: RefreshTokenRequest | undefined, signal?: AbortSignal): Promise<AuthenticationResponse>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    logout(body?: LogoutRequest | undefined, signal?: AbortSignal): Promise<void>;
    /**
     * @return OK
     */
    me(signal?: AbortSignal): Promise<ProfileResponse>;
    /**
     * @return OK
     */
    navigation(signal?: AbortSignal): Promise<NavigationItemResponse[]>;
}

export class AuthClient implements IAuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    login(body?: LoginRequest | undefined, signal?: AbortSignal): Promise<AuthenticationResponse> {
        let url_ = this.baseUrl + "/api/v1/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthenticationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refresh(body?: RefreshTokenRequest | undefined, signal?: AbortSignal): Promise<AuthenticationResponse> {
        let url_ = this.baseUrl + "/api/v1/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<AuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthenticationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    logout(body?: LogoutRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    me(signal?: AbortSignal): Promise<ProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<ProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProfileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileResponse>(null as any);
    }

    /**
     * @return OK
     */
    navigation(signal?: AbortSignal): Promise<NavigationItemResponse[]> {
        let url_ = this.baseUrl + "/api/v1/auth/me/navigation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNavigation(_response);
        });
    }

    protected processNavigation(response: AxiosResponse): Promise<NavigationItemResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<NavigationItemResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavigationItemResponse[]>(null as any);
    }
}

export interface IAuthorizationClient {
    /**
     * @param permission (optional) 
     * @return OK
     */
    get_authorization_check(permission?: string | undefined, signal?: AbortSignal): Promise<PermissionCheckResponse>;
    /**
     * @return OK
     */
    get_authorization_catalog(signal?: AbortSignal): Promise<AdministrationCatalogResponse>;
}

export class AuthorizationClient implements IAuthorizationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    get_authorization_check(permission?: string | undefined, signal?: AbortSignal): Promise<PermissionCheckResponse> {
        let url_ = this.baseUrl + "/api/v1/authorization/check?";
        if (permission === null)
            throw new globalThis.Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_authorization_check(_response);
        });
    }

    protected processGet_authorization_check(response: AxiosResponse): Promise<PermissionCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PermissionCheckResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionCheckResponse>(null as any);
    }

    /**
     * @return OK
     */
    get_authorization_catalog(signal?: AbortSignal): Promise<AdministrationCatalogResponse> {
        let url_ = this.baseUrl + "/api/v1/authorization/catalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_authorization_catalog(_response);
        });
    }

    protected processGet_authorization_catalog(response: AxiosResponse): Promise<AdministrationCatalogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AdministrationCatalogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdministrationCatalogResponse>(null as any);
    }
}

export interface IAutoUpdateClient {
    /**
     * @param currentVersion (optional) 
     * @param channel (optional) 
     * @return OK
     */
    gET_check(appCode: string, currentVersion?: string | undefined, channel?: string | undefined, signal?: AbortSignal): Promise<AppVersionCheckResponse>;
    /**
     * @param channel (optional) 
     * @return OK
     */
    gET_latest(appCode: string, channel?: string | undefined, signal?: AbortSignal): Promise<AppVersionCheckResponse>;
    /**
     * @return OK
     */
    gET_ByversionId_download(versionId: number, signal?: AbortSignal): Promise<void>;
    /**
     * @param channel (optional) 
     * @return OK
     */
    gET_manifest(appCode: string, channel?: string | undefined, signal?: AbortSignal): Promise<string>;
    /**
     * @return OK
     */
    gET_ByversionId_manifest(versionId: number, signal?: AbortSignal): Promise<string>;
    /**
     * @return OK
     */
    gET_ByversionId_files_ByfilePath(versionId: number, filePath: string, signal?: AbortSignal): Promise<void>;
}

export class AutoUpdateClient implements IAutoUpdateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param currentVersion (optional) 
     * @param channel (optional) 
     * @return OK
     */
    gET_check(appCode: string, currentVersion?: string | undefined, channel?: string | undefined, signal?: AbortSignal): Promise<AppVersionCheckResponse> {
        let url_ = this.baseUrl + "/api/autoupdate/check?";
        if (appCode === undefined || appCode === null)
            throw new globalThis.Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&";
        if (currentVersion === null)
            throw new globalThis.Error("The parameter 'currentVersion' cannot be null.");
        else if (currentVersion !== undefined)
            url_ += "currentVersion=" + encodeURIComponent("" + currentVersion) + "&";
        if (channel === null)
            throw new globalThis.Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGET_check(_response);
        });
    }

    protected processGET_check(response: AxiosResponse): Promise<AppVersionCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionCheckResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionCheckResponse>(null as any);
    }

    /**
     * @param channel (optional) 
     * @return OK
     */
    gET_latest(appCode: string, channel?: string | undefined, signal?: AbortSignal): Promise<AppVersionCheckResponse> {
        let url_ = this.baseUrl + "/api/autoupdate/latest?";
        if (appCode === undefined || appCode === null)
            throw new globalThis.Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&";
        if (channel === null)
            throw new globalThis.Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGET_latest(_response);
        });
    }

    protected processGET_latest(response: AxiosResponse): Promise<AppVersionCheckResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AppVersionCheckResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionCheckResponse>(null as any);
    }

    /**
     * @return OK
     */
    gET_ByversionId_download(versionId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/autoupdate/{versionId}/download";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGET_ByversionId_download(_response);
        });
    }

    protected processGET_ByversionId_download(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 206) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 302) {
            const _responseText = response.data;
            return throwException("Found", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param channel (optional) 
     * @return OK
     */
    gET_manifest(appCode: string, channel?: string | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/autoupdate/manifest?";
        if (appCode === undefined || appCode === null)
            throw new globalThis.Error("The parameter 'appCode' must be defined and cannot be null.");
        else
            url_ += "appCode=" + encodeURIComponent("" + appCode) + "&";
        if (channel === null)
            throw new globalThis.Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGET_manifest(_response);
        });
    }

    protected processGET_manifest(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    gET_ByversionId_manifest(versionId: number, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/autoupdate/{versionId}/manifest";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGET_ByversionId_manifest(_response);
        });
    }

    protected processGET_ByversionId_manifest(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    gET_ByversionId_files_ByfilePath(versionId: number, filePath: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/autoupdate/{versionId}/files/{filePath}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (filePath === undefined || filePath === null)
            throw new globalThis.Error("The parameter 'filePath' must be defined.");
        url_ = url_.replace("{filePath}", encodeURIComponent("" + filePath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGET_ByversionId_files_ByfilePath(_response);
        });
    }

    protected processGET_ByversionId_files_ByfilePath(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICatalogsClient {
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_nationalities(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfNationalityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_airports(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfAirportCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_flights(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfFlightCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_airlines(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfAirlineCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_occupations(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfOccupationCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_ethnicities(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfEthnicityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_religions(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfReligionCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_purposes(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfPurposeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_provinces(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfProvinceCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_border_gates(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfBorderGateCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_wards(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfWardCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_visa_symbols(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfVisaSymbolCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_visa_types(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfVisaTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_passport_types(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfPassportTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_approvers(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfApproverCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
}

export class CatalogsClient implements ICatalogsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_nationalities(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfNationalityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/nationalities?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_nationalities(_response);
        });
    }

    protected processGet_catalogs_nationalities(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfNationalityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfNationalityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfNationalityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_airports(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfAirportCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/airports?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_airports(_response);
        });
    }

    protected processGet_catalogs_airports(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfAirportCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfAirportCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfAirportCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_flights(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfFlightCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/flights?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_flights(_response);
        });
    }

    protected processGet_catalogs_flights(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfFlightCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfFlightCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfFlightCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_airlines(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfAirlineCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/airlines?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_airlines(_response);
        });
    }

    protected processGet_catalogs_airlines(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfAirlineCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfAirlineCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfAirlineCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_occupations(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfOccupationCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/occupations?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_occupations(_response);
        });
    }

    protected processGet_catalogs_occupations(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfOccupationCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfOccupationCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfOccupationCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_ethnicities(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfEthnicityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/ethnicities?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_ethnicities(_response);
        });
    }

    protected processGet_catalogs_ethnicities(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfEthnicityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfEthnicityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfEthnicityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_religions(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfReligionCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/religions?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_religions(_response);
        });
    }

    protected processGet_catalogs_religions(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfReligionCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfReligionCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfReligionCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_purposes(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfPurposeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/purposes?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_purposes(_response);
        });
    }

    protected processGet_catalogs_purposes(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfPurposeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfPurposeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfPurposeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_provinces(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfProvinceCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/provinces?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_provinces(_response);
        });
    }

    protected processGet_catalogs_provinces(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfProvinceCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfProvinceCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfProvinceCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_border_gates(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfBorderGateCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/border-gates?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_border_gates(_response);
        });
    }

    protected processGet_catalogs_border_gates(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfBorderGateCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfBorderGateCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfBorderGateCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_wards(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfWardCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/wards?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_wards(_response);
        });
    }

    protected processGet_catalogs_wards(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfWardCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfWardCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfWardCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_visa_symbols(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfVisaSymbolCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/visa-symbols?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_visa_symbols(_response);
        });
    }

    protected processGet_catalogs_visa_symbols(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfVisaSymbolCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfVisaSymbolCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfVisaSymbolCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_visa_types(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfVisaTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/visa-types?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_visa_types(_response);
        });
    }

    protected processGet_catalogs_visa_types(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfVisaTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfVisaTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfVisaTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_passport_types(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfPassportTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/passport-types?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_passport_types(_response);
        });
    }

    protected processGet_catalogs_passport_types(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfPassportTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfPassportTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfPassportTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_catalogs_approvers(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<CatalogPagedResponse_1OfOfApproverCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/catalogs/approvers?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_catalogs_approvers(_response);
        });
    }

    protected processGet_catalogs_approvers(response: AxiosResponse): Promise<CatalogPagedResponse_1OfOfApproverCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CatalogPagedResponse_1OfOfApproverCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogPagedResponse_1OfOfApproverCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }
}

export interface IGroupsClient {
    /**
     * @param query (optional) 
     * @param active (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_groups(query?: string | undefined, active?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<PagedResponse_1OfOfGroupSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param body (optional) 
     * @return OK
     */
    post_groups(body?: SaveGroupRequest | undefined, signal?: AbortSignal): Promise<GroupDetailResponse>;
    /**
     * @return OK
     */
    get_groups_Byid(id: number, signal?: AbortSignal): Promise<GroupDetailResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    put_groups_Byid(id: number, body?: SaveGroupRequest | undefined, signal?: AbortSignal): Promise<GroupDetailResponse>;
    /**
     * @return OK
     */
    delete_groups_Byid(id: number, signal?: AbortSignal): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    patch_groups_Byid_status(id: number, body?: ChangeStatusRequest | undefined, signal?: AbortSignal): Promise<void>;
}

export class GroupsClient implements IGroupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param query (optional) 
     * @param active (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_groups(query?: string | undefined, active?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<PagedResponse_1OfOfGroupSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/groups?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (active === null)
            throw new globalThis.Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_groups(_response);
        });
    }

    protected processGet_groups(response: AxiosResponse): Promise<PagedResponse_1OfOfGroupSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PagedResponse_1OfOfGroupSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResponse_1OfOfGroupSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    post_groups(body?: SaveGroupRequest | undefined, signal?: AbortSignal): Promise<GroupDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost_groups(_response);
        });
    }

    protected processPost_groups(response: AxiosResponse): Promise<GroupDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GroupDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupDetailResponse>(null as any);
    }

    /**
     * @return OK
     */
    get_groups_Byid(id: number, signal?: AbortSignal): Promise<GroupDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_groups_Byid(_response);
        });
    }

    protected processGet_groups_Byid(response: AxiosResponse): Promise<GroupDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GroupDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    put_groups_Byid(id: number, body?: SaveGroupRequest | undefined, signal?: AbortSignal): Promise<GroupDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut_groups_Byid(_response);
        });
    }

    protected processPut_groups_Byid(response: AxiosResponse): Promise<GroupDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GroupDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupDetailResponse>(null as any);
    }

    /**
     * @return OK
     */
    delete_groups_Byid(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_groups_Byid(_response);
        });
    }

    protected processDelete_groups_Byid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    patch_groups_Byid_status(id: number, body?: ChangeStatusRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/groups/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatch_groups_Byid_status(_response);
        });
    }

    protected processPatch_groups_Byid_status(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRolesClient {
    /**
     * @param query (optional) 
     * @param active (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_roles(query?: string | undefined, active?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<PagedResponse_1OfOfRoleSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param body (optional) 
     * @return OK
     */
    post_roles(body?: SaveRoleRequest | undefined, signal?: AbortSignal): Promise<RoleDetailResponse>;
    /**
     * @return OK
     */
    get_roles_Byid(id: number, signal?: AbortSignal): Promise<RoleDetailResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    put_roles_Byid(id: number, body?: SaveRoleRequest | undefined, signal?: AbortSignal): Promise<RoleDetailResponse>;
    /**
     * @return OK
     */
    delete_roles_Byid(id: number, signal?: AbortSignal): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    patch_roles_Byid_status(id: number, body?: ChangeStatusRequest | undefined, signal?: AbortSignal): Promise<void>;
}

export class RolesClient implements IRolesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param query (optional) 
     * @param active (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    get_roles(query?: string | undefined, active?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<PagedResponse_1OfOfRoleSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/v1/roles?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (active === null)
            throw new globalThis.Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_roles(_response);
        });
    }

    protected processGet_roles(response: AxiosResponse): Promise<PagedResponse_1OfOfRoleSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PagedResponse_1OfOfRoleSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResponse_1OfOfRoleSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    post_roles(body?: SaveRoleRequest | undefined, signal?: AbortSignal): Promise<RoleDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost_roles(_response);
        });
    }

    protected processPost_roles(response: AxiosResponse): Promise<RoleDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RoleDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDetailResponse>(null as any);
    }

    /**
     * @return OK
     */
    get_roles_Byid(id: number, signal?: AbortSignal): Promise<RoleDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_roles_Byid(_response);
        });
    }

    protected processGet_roles_Byid(response: AxiosResponse): Promise<RoleDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RoleDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    put_roles_Byid(id: number, body?: SaveRoleRequest | undefined, signal?: AbortSignal): Promise<RoleDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut_roles_Byid(_response);
        });
    }

    protected processPut_roles_Byid(response: AxiosResponse): Promise<RoleDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RoleDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDetailResponse>(null as any);
    }

    /**
     * @return OK
     */
    delete_roles_Byid(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_roles_Byid(_response);
        });
    }

    protected processDelete_roles_Byid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    patch_roles_Byid_status(id: number, body?: ChangeStatusRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/roles/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatch_roles_Byid_status(_response);
        });
    }

    protected processPatch_roles_Byid_status(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUsersClient {
    /**
     * @return OK
     */
    get_users(signal?: AbortSignal): Promise<UserSummaryResponse[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    post_users(body?: SaveUserRequest | undefined, signal?: AbortSignal): Promise<UserSummaryResponse>;
    /**
     * @return OK
     */
    get_users_Byid(id: number, signal?: AbortSignal): Promise<UserSummaryResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    put_users_Byid(id: number, body?: SaveUserRequest | undefined, signal?: AbortSignal): Promise<UserSummaryResponse>;
    /**
     * @return OK
     */
    delete_users_Byid(id: number, signal?: AbortSignal): Promise<void>;
    /**
     * @return OK
     */
    get_users_catalog(signal?: AbortSignal): Promise<UserEditorCatalogResponse>;
    /**
     * @param body (optional) 
     * @return OK
     */
    patch_users_Byid_lock(id: number, body?: ChangeUserLockRequest | undefined, signal?: AbortSignal): Promise<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    post_users_Byid_reset_password(id: number, body?: ResetUserPasswordRequest | undefined, signal?: AbortSignal): Promise<void>;
}

export class UsersClient implements IUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    get_users(signal?: AbortSignal): Promise<UserSummaryResponse[]> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_users(_response);
        });
    }

    protected processGet_users(response: AxiosResponse): Promise<UserSummaryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserSummaryResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSummaryResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    post_users(body?: SaveUserRequest | undefined, signal?: AbortSignal): Promise<UserSummaryResponse> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost_users(_response);
        });
    }

    protected processPost_users(response: AxiosResponse): Promise<UserSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSummaryResponse>(null as any);
    }

    /**
     * @return OK
     */
    get_users_Byid(id: number, signal?: AbortSignal): Promise<UserSummaryResponse> {
        let url_ = this.baseUrl + "/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_users_Byid(_response);
        });
    }

    protected processGet_users_Byid(response: AxiosResponse): Promise<UserSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSummaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    put_users_Byid(id: number, body?: SaveUserRequest | undefined, signal?: AbortSignal): Promise<UserSummaryResponse> {
        let url_ = this.baseUrl + "/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut_users_Byid(_response);
        });
    }

    protected processPut_users_Byid(response: AxiosResponse): Promise<UserSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSummaryResponse>(null as any);
    }

    /**
     * @return OK
     */
    delete_users_Byid(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete_users_Byid(_response);
        });
    }

    protected processDelete_users_Byid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    get_users_catalog(signal?: AbortSignal): Promise<UserEditorCatalogResponse> {
        let url_ = this.baseUrl + "/api/v1/users/catalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet_users_catalog(_response);
        });
    }

    protected processGet_users_catalog(response: AxiosResponse): Promise<UserEditorCatalogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserEditorCatalogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEditorCatalogResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    patch_users_Byid_lock(id: number, body?: ChangeUserLockRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{id}/lock";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatch_users_Byid_lock(_response);
        });
    }

    protected processPatch_users_Byid_lock(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    post_users_Byid_reset_password(id: number, body?: ResetUserPasswordRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{id}/reset-password";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost_users_Byid_reset_password(_response);
        });
    }

    protected processPost_users_Byid_reset_password(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface AdministrationCatalogResponse {
    modules?: PermissionModuleResponse[] | undefined;
    roles?: LookupResponse[] | undefined;
    users?: UserLookupResponse[] | undefined;
    borderGates?: BorderGateLookupResponse[] | undefined;
}

export interface BorderGateLookupResponse {
    code?: string | undefined;
    name?: string | undefined;
}

export interface ChangeStatusRequest {
    isActive?: boolean;
}

export interface GroupDetailResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    userIds?: number[] | undefined;
    roleIds?: number[] | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    borderGateCode?: string | undefined;
    borderGateName?: string | undefined;
}

export interface GroupSummaryResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    userCount?: number;
    roleCount?: number;
    borderGateCode?: string | undefined;
    borderGateName?: string | undefined;
}

export interface LookupResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
}

export interface PagedResponse_1OfOfGroupSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: GroupSummaryResponse[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface PagedResponse_1OfOfRoleSummaryResponseAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: RoleSummaryResponse[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface PermissionModuleResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    permissions?: PermissionResponse[] | undefined;
}

export interface PermissionResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export interface RoleDetailResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    permissionIds?: number[] | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface RoleSummaryResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    permissionCount?: number;
}

export interface SaveGroupRequest {
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    userIds?: number[] | undefined;
    roleIds?: number[] | undefined;
    borderGateCode?: string | undefined;
}

export interface SaveRoleRequest {
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    permissionIds?: number[] | undefined;
}

export interface UserLookupResponse {
    id?: number;
    userName?: string | undefined;
    displayName?: string | undefined;
    borderGateCode?: string | undefined;
    userTypeCode?: string | undefined;
}

export interface AuthenticationResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    accessTokenExpiresAtUtc?: Date;
    refreshTokenExpiresAtUtc?: Date;
    user?: UserResponse;
    permissions?: string[] | undefined;
    modules?: ModuleResponse[] | undefined;
    navigation?: NavigationItemResponse[] | undefined;
}

export interface LoginRequest {
    userName: string;
    password: string;
    rememberMe?: boolean;
}

export interface LogoutRequest {
    refreshToken: string;
}

export interface ModuleResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    webMethods?: string | undefined;
    appMethod?: string | undefined;
    sortOrder?: number;
    isClient?: boolean;
}

export interface NavigationItemResponse {
    screenKey?: string | undefined;
    moduleCode?: string | undefined;
    displayName?: string | undefined;
    sortOrder?: number;
    groupKey?: string | undefined;
    groupName?: string | undefined;
}

export interface ProfileResponse {
    user?: UserResponse;
    permissions?: string[] | undefined;
    modules?: ModuleResponse[] | undefined;
    navigation?: NavigationItemResponse[] | undefined;
}

export interface RefreshTokenRequest {
    refreshToken: string;
}

export interface UserResponse {
    id?: number;
    userName?: string | undefined;
    displayName?: string | undefined;
    isSuperUser?: boolean;
    groups?: string[] | undefined;
    roles?: string[] | undefined;
    userTypeCode?: string | undefined;
    borderGateCode?: string | undefined;
}

export interface PermissionCheckResponse {
    permission?: string | undefined;
    isGranted?: boolean;
}

export interface AirlineCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    countryCode?: string | undefined;
}

export interface AirportCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    countryCode?: string | undefined;
}

export interface ApproverCatalogItem {
    id?: string | undefined;
    recordType?: string | undefined;
    account?: string | undefined;
    effectiveFrom?: Date | undefined;
    effectiveTo?: Date | undefined;
    status?: number | undefined;
}

export interface BorderGateCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    administrativeCode?: string | undefined;
}

export interface CatalogPagedResponse_1OfOfAirlineCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AirlineCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfAirportCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AirportCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfApproverCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: ApproverCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfBorderGateCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: BorderGateCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfEthnicityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: EthnicityCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfFlightCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: FlightCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfNationalityCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: NationalityCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfOccupationCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: OccupationCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfPassportTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: PassportTypeCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfProvinceCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: ProvinceCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfPurposeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: PurposeCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfReligionCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: ReligionCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfVisaSymbolCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: VisaSymbolCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfVisaTypeCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: VisaTypeCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface CatalogPagedResponse_1OfOfWardCatalogItemAndApiAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: WardCatalogItem[] | undefined;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export interface EthnicityCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    otherName?: string | undefined;
    description?: string | undefined;
}

export interface FlightCatalogItem {
    id?: string | undefined;
    flightNumber?: string | undefined;
    name?: string | undefined;
    routeCode?: string | undefined;
    airlineCode?: string | undefined;
    airportCode?: string | undefined;
    type?: string | undefined;
    note?: string | undefined;
}

export interface NationalityCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    vietnameseName?: string | undefined;
}

export interface OccupationCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    englishName?: string | undefined;
    description?: string | undefined;
}

export interface PassportTypeCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ProvinceCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    searchName?: string | undefined;
    otherCode?: string | undefined;
    note?: string | undefined;
}

export interface PurposeCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    englishName?: string | undefined;
    description?: string | undefined;
}

export interface ReligionCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface VisaSymbolCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface VisaTypeCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface WardCatalogItem {
    id?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    districtCode?: string | undefined;
    note?: string | undefined;
}

export interface BorderGateLookupResponse2 {
    code?: string | undefined;
    name?: string | undefined;
}

export interface ChangeUserLockRequest {
    isLocked?: boolean;
}

export interface ResetUserPasswordRequest {
    password?: string | undefined;
}

export interface SaveUserRequest {
    userName?: string | undefined;
    fullName?: string | undefined;
    userTypeCode?: string | undefined;
    borderGate?: string | undefined;
    organization?: string | undefined;
    groupIds?: number[] | undefined;
    password?: string | undefined;
}

export interface UserEditorCatalogResponse {
    groups?: UserGroupLookupResponse[] | undefined;
    userTypes?: string[] | undefined;
    borderGates?: BorderGateLookupResponse2[] | undefined;
    creatableUserTypes?: string[] | undefined;
}

export interface UserGroupLookupResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    borderGateCode?: string | undefined;
}

export interface UserSummaryResponse {
    id?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    userTypeCode?: string | undefined;
    borderGateCode?: string | undefined;
    borderGateName?: string | undefined;
    organization?: string | undefined;
    groupIds?: number[] | undefined;
    groupNames?: string[] | undefined;
    isActive?: boolean;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface CreateAppVersionRequest {
    appCode: string;
    version: string;
    channel?: string | undefined;
    releaseNotes?: string | undefined;
    downloadUrl?: string | undefined;
    isMandatory?: boolean;
    minSupportedVersion?: string | undefined;
}

export interface UpdateAppVersionRequest {
    releaseNotes?: string | undefined;
    downloadUrl?: string | undefined;
    isMandatory?: boolean;
    minSupportedVersion?: string | undefined;
}

export interface AppVersionCheckResponse {
    hasUpdate?: boolean;
    isMandatory?: boolean;
    currentVersion?: string | undefined;
    latestVersion?: string | undefined;
    minSupportedVersion?: string | undefined;
    channel?: string | undefined;
    versionId?: number | undefined;
    releaseNotes?: string | undefined;
    fileName?: string | undefined;
    fileSize?: number | undefined;
    checksum?: string | undefined;
    downloadUrl?: string | undefined;
    manifestUrl?: string | undefined;
    cdnBaseUrl?: string | undefined;
    publishedAt?: Date | undefined;
}

export interface AppVersionResponse {
    versionId?: number;
    appCode?: string | undefined;
    version?: string | undefined;
    major?: number;
    minor?: number;
    build?: number;
    revision?: number;
    channel?: string | undefined;
    releaseNotes?: string | undefined;
    fileName?: string | undefined;
    fileSize?: number | undefined;
    checksum?: string | undefined;
    downloadUrl?: string | undefined;
    manifestUrl?: string | undefined;
    cdnBaseUrl?: string | undefined;
    isMandatory?: boolean;
    minSupportedVersion?: string | undefined;
    status?: string | undefined;
    hasPackage?: boolean;
    publishedAt?: Date | undefined;
    createdBy?: string | undefined;
    regDate?: Date;
    updatedBy?: string | undefined;
    lastUpdate?: Date | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}